class AutomaticImportController extends AbstractIntegrationController
	@register()
	@inject '$scope',
		'$filter'
		'$sce'
		'configurationOptions'
		'configuration'

	integrationId: 'automatic_import'

	initialize: ->
		@resetConfig() if _.isEmpty @configuration

		instructionParams =
			prefix: 'products'
			extension: '.csv'
			fileSize: '1 Mb'
			processedFolderName: 'processed'
		@instructions = @$sce.trustAsHtml(
			@$filter('translate')('wbo.integration.automatic_import.instructions', instructionParams).toString()
		)

		# Needs to be directly in scope because of sftp-form.html
		@$scope.configuration = @configuration
		@$scope.isNew = !@configuration?.is_active?
		@$scope.changingPassword = false

	runIntegration: ->
		@saving = true

		@IntegrationRepository
			.run @integrationId, []
			.then (response) =>
				@ToastService.add(
					@$filter('translate')('alert.import.task.scheduled').toString(),
					@$filter('translate')(@headerText),
					@$filter('translate')('general.integration'),
					'success'
				)
			.catch (response) =>
				@ToastService.showErrors response, @$filter('translate')(@headerText).toString()
			.finally =>
				@saving = false

	disconnect: ->
		super().then => @resetConfig()

	save: ->
		if !@$scope.isNew && !@$scope.changingPassword
			delete @configuration.password

		super(@configuration)
			.then =>
				@$scope.isNew = false
				@disablePasswordChange()

	enablePasswordChange: ->
		@$scope.changingPassword = true

	disablePasswordChange: ->
		@$scope.changingPassword = false

		delete @configuration.password

	resetConfig: ->
		@configuration =
			path: './'
			port: 22
			isSftp: true
		@$scope.configuration = @configuration
		@$scope.isNew = false
